(ns storrito.ui.table)

(def cell-padding
  ["px-4"
   "py-4"
   "sm:px-6"
   "sm:py-4"])

(def tr
  ["bg-white"
   "hover:bg-gray-50"])

(def th
  (concat ["text-left"
           "text-xs"
           "font-medium"
           "text-gray-500"
           "uppercase"
           "tracking-wider"]
          cell-padding))

(def td
  (concat ["whitespace-nowrap"
           "text-gray-800"
           "align-middle"]
          cell-padding))

(def table
  ["min-w-full"
   "divide-y"
   "divide-gray-200"
   "table-auto"])

(def thead
  ["bg-gray-50"])

(def tbody
  ["bg-white"
   "divide-y"
   "divide-gray-200"])

(defn table-element
  [{:keys [headers rows]}]
  [:table.min-w-full.divide-y.divide-gray-300
   [:thead
    [:tr
     (doall
       (map-indexed (fn [idx header]
                      (if (= idx 0)
                        ^{:key (str "table-header: " idx ": " header)}
                        [:th.py-3.5.pl-4.pr-3.text-left.text-sm.font-semibold.text-gray-900 {:scope "col"} header]
                        ^{:key (str "table-header: " idx ": " header)}
                        [:th.px-3.py-3.5.text-left.text-sm.font-semibold.text-gray-900 {:scope "col"} header]))
                    headers))]]
   [:tbody.divide-y.divide-gray-200
    (doall
      (map-indexed
        (fn [idx-row row]
          (if (:break-row row)
            (:break-row row)
            ^{:key (str "table-row: " idx-row)}
            [:tr
             (doall
               (map-indexed
                 (fn [idx-col col]
                   (if (:custom col)
                     (:custom col)
                     ^{:key (str "table-col: " idx-col)}
                     [:td.whitespace-nowrap.py-4.pl-4.text-sm.text-gray-500 col]))
                 row))]))
        rows))]])

(defn table-element-full
  [{:keys [title description headers rows]}]
  [:div.px-4.sm:px-6.lg:px-8
   [:div.sm:flex.sm:items-center
    [:div.sm:flex-auto
     [:h1.text-xl.font-semibold.text-gray-900 title]
     [:div.mt-2.text-sm.text-gray-700 description]]]
   [:div.mt-8.flex.flex-col
    [:div.-my-2.-mx-4.overflow-x-auto.sm:-mx-6.lg:-mx-8
     [:div.inline-block.min-w-full.py-2.align-middle.md:px-6.lg:px-8
      [:div.overflow-hidden.shadow.ring-1.ring-black.ring-opacity-5.md:rounded-lg
       [table-element {:headers headers
                       :rows rows}]]]]]])
